// extracted by mini-css-extract-plugin
export default {"mid-box":"AppVersion_mid-box__y60+0","content-box":"AppVersion_content-box__ETC4T","top":"AppVersion_top__VE3bn","botm":"AppVersion_botm__Fgi4z"};